export const PAGE_LAYOUT = {
    contentMaxWidth: 840,
    columnGap: 4,
    copyColumnWidth: 256,
    fieldsColumnWidth: 552,
    sectionGap: 5,
};

export const FIELD_SPACING_SX = {
    mb: 2.5,
    "& .MuiOutlinedInput-root": {
        minHeight: 56,
    },
};

export const AUTOCOMPLETE_POPPER_PROPS = {
    slotProps: {
        popper: {
            sx: { zIndex: 1400 },
        },
    },
};

export const getRootSaftLegalStructureId = (countryCode) => {
    if (!countryCode || countryCode.length !== 2) return "";
    const token = countryCode.charAt(0).toUpperCase() + countryCode.slice(1).toLowerCase();
    return `Saft${token}File`;
};

export const isRootSaftLegalStructureId = (structureId = "") =>
    /^Saft[A-Z][a-z]File$/.test(structureId);

export const filterLegacyLegalStructures = (structures = [], countryCode = "") => {
    if (!structures.length) return structures;

    const rootStructures = structures.filter((structure) =>
        isRootSaftLegalStructureId(structure.id),
    );
    if (rootStructures.length) return rootStructures;

    const rootId = getRootSaftLegalStructureId(countryCode);
    const legacyRoot = structures.filter((structure) => structure.id === rootId);
    return legacyRoot.length ? legacyRoot : [structures[0]];
};

export const EXCLUDED_LEGAL_STRUCTURE_IDS = new Set(["AVA", "SaftRoAvaFile"]);

export const filterLegalStructures = (structures = [], countryCode = "") => {
    const withoutExcluded = structures.filter(
        (structure) => !EXCLUDED_LEGAL_STRUCTURE_IDS.has(structure.id),
    );
    const hasCatalogIds = withoutExcluded.some(
        (structure) =>
            /^SAFT_[A-Z]{2}$/.test(structure.id) ||
            structure.id === "DMR" ||
            /^AO_M/.test(structure.id),
    );
    if (hasCatalogIds) return withoutExcluded;
    return filterLegacyLegalStructures(withoutExcluded, countryCode);
};

export const preferredLegalStructure = (structures = []) =>
    structures.find((structure) => /^SAFT_[A-Z]{2}$/.test(structure.id)) ||
    structures.find((structure) => isRootSaftLegalStructureId(structure.id)) ||
    structures[0];

export const ENTITY_PICKER_FLAT_LIST_SX = {
    maxHeight: 264,
    overflowY: "auto",
    "& .MuiTreeItem-iconContainer": {
        display: "none !important",
    },
    "& [class*='iconContainer']": {
        display: "none !important",
    },
    "& [class*='expandIcon']": {
        display: "none !important",
    },
    "& svg[class*='expand']": {
        display: "none !important",
    },
    "& .MuiTreeItem-content": {
        paddingLeft: "8px !important",
    },
    "& [class*='content']": {
        paddingLeft: "8px !important",
    },
};
